export const authenticationProps = {
    AUTH: 'auth',
    UNAUTH: 'unAuth',
}

export const LAYOUT_TYPES = {
    NONE: 'none',
    MAIN:'main',
}